// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2WRst","alertIcon":"ConfirmModal_alertIcon__3dtdO"};